/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListTemplatesRequest,
  ListTemplatesSecurity,
} from "../models/operations/listtemplates.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildTemplatesQuery,
  prefetchTemplates,
  queryKeyTemplates,
  TemplatesQueryData,
} from "./templates.core.js";
export {
  buildTemplatesQuery,
  prefetchTemplates,
  queryKeyTemplates,
  type TemplatesQueryData,
};

export type TemplatesQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listTemplates templates
 *
 * @remarks
 * List available prompt template.
 */
export function useTemplates(
  request?: ListTemplatesRequest | undefined,
  security?: ListTemplatesSecurity | undefined,
  options?: QueryHookOptions<TemplatesQueryData, TemplatesQueryError>,
): UseQueryResult<TemplatesQueryData, TemplatesQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildTemplatesQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listTemplates templates
 *
 * @remarks
 * List available prompt template.
 */
export function useTemplatesSuspense(
  request?: ListTemplatesRequest | undefined,
  security?: ListTemplatesSecurity | undefined,
  options?: SuspenseQueryHookOptions<TemplatesQueryData, TemplatesQueryError>,
): UseSuspenseQueryResult<TemplatesQueryData, TemplatesQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildTemplatesQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setTemplatesData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      gramKey?: string | undefined;
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: TemplatesQueryData,
): TemplatesQueryData | undefined {
  const key = queryKeyTemplates(...queryKeyBase);

  return client.setQueryData<TemplatesQueryData>(key, data);
}

export function invalidateTemplates(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      gramKey?: string | undefined;
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "templates", "list", ...queryKeyBase],
  });
}

export function invalidateAllTemplates(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "templates", "list"],
  });
}
